"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRentersWidgets = void 0;
var RentersNeedsAndDemandsWidget_1 = require("./RentersNeedsAndDemandsWidget");
var PropertyTypeWidget_1 = require("./PropertyTypeWidget");
var RentersPremiumOutputWidget_1 = require("./RentersPremiumOutputWidget");
var BathroomInfoCollapseWidget_1 = require("./BathroomInfoCollapseWidget");
var CoverLimitsWidget_1 = require("./CoverLimitsWidget");
var CoveredAnywhereWidget_1 = require("./coveredAnywhereWidget/CoveredAnywhereWidget");
var RentersQuoteSummaryPanelWidget_1 = require("./RentersQuoteSummaryPanelWidget");
var WhatIsCoveredWidget_1 = require("./WhatIsCoveredWidget");
var AddItemPriceOutputWidget_1 = require("./AddItemPriceOutputWidget");
var RemoveItemPriceOutputWidget_1 = require("./RemoveItemPriceOutputWidget");
var EditItemPriceOutputWidget_1 = require("./EditItemPriceOutputWidget");
var EmploymentStatusPriceOutputWidget_1 = require("./EmploymentStatusPriceOutputWidget");
var OtherResidentsPriceOutputWidget_1 = require("./OtherResidentsPriceOutputWidget");
var EditRentersCoverPriceOutputWidget_1 = require("./EditRentersCoverPriceOutputWidget");
var EditRentersClaimsPriceOutputWidget_1 = require("./EditRentersClaimsPriceOutputWidget");
var RentersCoverDetailsDisplayWidget_1 = require("./RentersCoverDetailsDisplayWidget");
var AddressIsNotMatchModalWidget_1 = require("./AddressIsNotMatchModalWidget");
var RentersCancellationSuccessWidget_1 = require("./RentersCancellationSuccessWidget");
var RentersAssumptionsPopupWidget_1 = require("./RentersAssumptionsPopupWidget");
var OtherResidentsChangeDeclineTextOutputWidget_1 = require("./OtherResidentsChangeDeclineTextOutputWidget");
var OtherResidentsPopupWidget_1 = require("./OtherResidentsPopupWidget");
var addRentersWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "rentersNeedsAndDemandsOutput",
        component: RentersNeedsAndDemandsWidget_1.RentersNeedsAndDemandsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "propertyTypeOutput",
        component: PropertyTypeWidget_1.PropertyTypeWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "rentersPremiumOutput",
        component: RentersPremiumOutputWidget_1.RentersPremiumOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "bathroomInfoOutput",
        component: BathroomInfoCollapseWidget_1.BathroomInfoCollapseWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "coverLimitsWidget",
        component: CoverLimitsWidget_1.CoverLimitsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "coveredAnywhereWidget",
        component: CoveredAnywhereWidget_1.CoveredAnywhereWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "rentersQuoteSummaryPanelWidget",
        component: RentersQuoteSummaryPanelWidget_1.RentersQuoteSummaryPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "whatIsCoveredWidget",
        component: WhatIsCoveredWidget_1.default
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addItemPriceOutput",
        component: AddItemPriceOutputWidget_1.AddItemPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "removeItemPriceOutput",
        component: RemoveItemPriceOutputWidget_1.RemoveItemPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "editItemPriceOutput",
        component: EditItemPriceOutputWidget_1.EditItemPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "employmentStatusPriceOutput",
        component: EmploymentStatusPriceOutputWidget_1.EmploymentStatusPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "otherResidentsPriceOutput",
        component: OtherResidentsPriceOutputWidget_1.OtherResidentsPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "editRentersCoverPriceOutput",
        component: EditRentersCoverPriceOutputWidget_1.EditRentersCoverPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "editRentersClaimsPriceOutput",
        component: EditRentersClaimsPriceOutputWidget_1.EditRentersClaimsPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "rentersCoverDetailsDisplayWidget",
        component: RentersCoverDetailsDisplayWidget_1.RentersCoverDetailsDisplayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addressIsNotMatchModal",
        component: AddressIsNotMatchModalWidget_1.AddressIsNotMatchModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "rentersCancellationSuccess",
        component: RentersCancellationSuccessWidget_1.RentersCancellationSuccessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "rentersAssumptionsPopup",
        component: RentersAssumptionsPopupWidget_1.RentersAssumptionsPopupWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "otherResidentsChangeDeclineText",
        component: OtherResidentsChangeDeclineTextOutputWidget_1.OtherResidentsChangeDeclineTextOutputWidget,
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "otherResidentsPopup",
        component: OtherResidentsPopupWidget_1.OtherResidentsPopupWidget
    });
};
exports.addRentersWidgets = addRentersWidgets;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/index.js
// module id = 2548
// module chunks = 0